import { CircularProgress } from "@mui/material";

const circularProgressSize = 200;

export default function StyledCircularProgress() {
  return (
    <CircularProgress size={circularProgressSize} style={{
      top: `calc(50% - ${circularProgressSize / 2}px)`,
      left: `calc(50% - ${circularProgressSize / 2}px)`,
      position: 'absolute'
    }} />
  );
};